import { Link } from '@tanstack/react-router';
import { ShieldCheck } from 'lucide-react';
import { Button, DialogBody, DialogFooter } from '@/shared/components';

/**
 * Support-Sitzungen verlangen die Zwei-Faktor-Anmeldung am eigenen Konto. Eingerichtet wird sie
 * in der Kontosicherheit der Heimatsitzung, nicht in diesem Dialog.
 */
export function SupportTwoFactorHint({ onClose }: { onClose: () => void }) {
  return (
    <>
      <DialogBody className="space-y-3">
        <div className="border-line bg-card-alt/50 flex gap-3 rounded-md border p-4">
          <ShieldCheck size={20} aria-hidden className="text-sage mt-0.5 flex-none" />
          <div className="min-w-0 text-sm">
            <p className="text-ink font-semibold">Zwei-Faktor-Anmeldung fehlt</p>
            <p className="text-ink-soft mt-1">
              Eine Support-Sitzung öffnet Kundendaten. Sie beginnt deshalb nur mit einem frischen
              Code aus Ihrer Authenticator-App. Richten Sie die Zwei-Faktor-Anmeldung an Ihrem
              eigenen Konto ein und starten Sie die Sitzung danach erneut.
            </p>
          </div>
        </div>
      </DialogBody>
      <DialogFooter className="flex-col-reverse items-stretch sm:flex-row sm:items-center">
        <Button type="button" variant="ghost" className="min-h-11" onClick={onClose}>
          Schließen
        </Button>
        <Button asChild variant="brand" className="min-h-11">
          <Link to="/account/security" onClick={onClose}>
            Zwei-Faktor-Anmeldung einrichten
          </Link>
        </Button>
      </DialogFooter>
    </>
  );
}
